import React from "react";
import { PlusIcon, ListIcon } from "../../../components/icons";
import { Button } from "../../../components/ui/button";
import { DocumentReference } from "../../../platform/word/documentTools";

interface ReferenceListProps {
  onAddReference: () => void;
  onEditReference: (reference: DocumentReference) => void;
  onViewExisting: () => void;
}

/** The Assembly landing view: the two things you can do here, and nothing else. */
const ReferenceList = ({ onAddReference, onViewExisting }: ReferenceListProps) => {
  return (
    <div className="flex flex-col gap-2 px-3.5 py-4">
      <Button size="lg" onClick={onAddReference}>
        <PlusIcon />
        Insert new reference
      </Button>
      <Button variant="secondary-outline" size="lg" onClick={onViewExisting}>
        <ListIcon />
        View existing references
      </Button>
    </div>
  );
};

export default ReferenceList;
